import { Col, Form, Input, Row } from 'antd'
import { useChangePassword } from 'api/Admin'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { adminSettingStore } from 'state/setting/admin'
import { myStore } from 'state/store'

interface ChangePasswordModalProps {
  firebaseId: string
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  firebaseId,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const { changePasswordModal, setChangePasswordModal } = adminSettingStore(
    store => ({
      changePasswordModal: store.changePasswordModal,
      setChangePasswordModal: store.setChangePasswordModal,
    }),
  )
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const { mutate: changePassword } = useChangePassword()

  const closeModal = () => {
    setChangePasswordModal(false)
  }

  const handleFinish = (values: {
    newPassword: string
    confirmPassword: string
  }) => {
    const payload = {
      password: values.newPassword,
      firebaseId: firebaseId,
    }
    setModalBtnLoader(true)
    changePassword(payload, {
      onSuccess: () => {
        setModalBtnLoader(false)
        closeModal()
      },
    })
  }

  return (
    <>
      <CustomModal
        openModal={changePasswordModal}
        isCloseModalCustom={true}
        closeModal={closeModal}
        title="Change Password"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Cancel,Save"
            closeModal={closeModal}
            onSubmit={handleSubmit}
          />
        }
      >
        <>
          <Form layout="vertical" form={form} onFinish={handleFinish}>
            <Row>
              <Col>
                <label className="input-label required-input">
                  New Password
                </label>
                <Form.Item
                  name={'newPassword'}
                  className="form-control allergies-field "
                  rules={[
                    { required: true, message: 'Password is required' },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve()
                        const complexityRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/
                        return complexityRegex.test(value)
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error(
                                'Password must be at least 8 characters, include 1 uppercase letter and 1 number',
                              ),
                            )
                      },
                    },
                  ]}
                >
                  <Input.Password
                    className="custom-input-field"
                    placeholder="Enter new password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <label className="input-label required-input">
                  Confirm Password
                </label>
                <Form.Item
                  name={'confirmPassword'}
                  className="form-control allergies-field "
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Password is required' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          new Error('Passwords do not match'),
                        )
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    className="custom-input-field"
                    placeholder="Confirm new password"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      </CustomModal>
    </>
  )
}

export default ChangePasswordModal
